<mat-card appearance="outlined" class="formula-card">
  <mat-card-content class="formula-card__content">
    @if (!editMode) {
      <div class="formula-view-body">
        <strong>Formula:&nbsp;</strong>
        @for (part of formulaParts; track part) {
          {{ part.math }} <span class="formula-view-input">{{ getName(part) }}</span>
        }
      </div>
    }

    @if (editMode) {
      <mat-form-field style="margin-left: 1rem; width: 30%">
        <mat-label>Name</mat-label>
        <input matInput placeholder="Name" type="text" [value]="formula.name" [(ngModel)]="formula.name" />
      </mat-form-field>
      <mat-form-field style="margin-left: 1rem; width: 70%">
        <mat-label>Description</mat-label>
        <input matInput placeholder="Description" type="text" [value]="formula.description" [(ngModel)]="formula.description" />
      </mat-form-field>
      <hr />
      <table class="table table-sm table-borderless" style="width: auto">
        <tr aria-live="polite">
          <th scope="row">Formula:</th>
          <td style="margin-left: 1rem; font-weight: 400">
            @for (part of formulaParts; track part) {
              {{ part.math }}{{ getName(part) }}
            }
          </td>
        </tr>
        <tr aria-live="polite">
          <th scope="row">Evaluation:</th>
          <td style="margin-left: 1rem; font-weight: 400">
            <span>
              {{ formulaSolve() }}
              <strong>{{ solution | async | number }}</strong>
            </span>
          </td>
        </tr>
        <tr>
          <td></td>
          <td style="margin-left: 1rem">
            <em>Evaluation uses test values below to attempt a calculation</em>
            <br />
            <span><em>Parenthesis cannot be used to denote "multiply" you must use the "*" operator.</em></span>
          </td>
        </tr>
      </table>
      <div class="formula-inputs-scroll" appKeyboardScrollable>
        <table class="table" style="width: auto">
          <thead>
            <th scope="col">Math<br /><span class="description">Digits and operators only</span></th>
            <th scope="col">Input<br /><span class="description">Incorporate results from question, tables, or calculations</span></th>
            <th scope="col">Test Value<br /><span class="description">Sample to test function</span></th>
            <th scope="col">Action</th>
          </thead>
          @for (part of formulaParts; track part; let i = $index) {
            <tr>
              <td>
                <mat-form-field>
                  <mat-label>Math Operator</mat-label>
                  <input matInput #mathOperatorInput type="text" placeholder="Math Operator" [value]="part.math" [(ngModel)]="part.math" formulaOnly />
                </mat-form-field>
              </td>
              <td>
                <input-selector [key]="part" [caller]="'Formula'"></input-selector>
              </td>
              <td>
                @if (part.type !== "New") {
                  <span>
                    <mat-form-field style="width: 8rem">
                      <mat-label>Test Value</mat-label>
                      <input matInput type="number" placeholder="Test Value" [value]="part.value" [(ngModel)]="part.value" />
                    </mat-form-field>
                  </span>
                }
              </td>
              <td>
                @if (i !== formulaParts.length - 1 || part.type !== "New") {
                  <div style="display: flex; align-items: center; gap: 0.5rem; min-height: 3.5rem">
                    <button mat-button color="warn" (click)="deletePart(i)">delete</button>
                    <button mat-button color="secondary" (click)="formulaParts.splice(i + 1, 0, { math: '', type: 'New', value: 0 })">add input</button>
                  </div>
                }
              </td>
            </tr>
          }
        </table>
      </div>
    }
  </mat-card-content>

  @if (editMode) {
    <div class="formula-save-bar">
      <button mat-button type="button" (click)="cancelEdit.emit()">Cancel</button>
      <button mat-flat-button color="accent" (click)="saveFormula.emit()" [disabled]="!editMode">Save</button>
    </div>
  } @else {
    <div class="formula-save-bar">
      <button mat-flat-button color="primary" (click)="edit.emit()">Edit</button>
      <button mat-stroked-button color="warn" (click)="delete.emit()" [disabled]="isNew">Delete</button>
    </div>
  }
</mat-card>
